<template>
    <div>
        <div class="modal-mask modal-container" v-if="popupState && !endState">
        <div class="popup-event-wrap">
            <div class="image-container image-area">
                <img src="../../assets/images/end/m-pop-apology-wavve.png"/>
            </div>

            <div class="popup-event-bottom">
            <div class="check-style">
                <input v-model="dayClose" type="checkbox" id="ch-today" class="check-purple-round"><label for="ch-today">오늘 하루 보지 않기</label>
            </div>
            <button @click="closePopup()" class="close-event-popup">닫기</button>
            </div>
        </div>
        </div>
        <div class="modal-mask modal-container" v-if="popupState && endState">
        <div class="popup-event-wrap">
            <div class="image-container image-area">
                <img src="../../assets/images/end/m-pop-service-end-wavve.png"/>
            </div>

            <div class="popup-event-bottom">
            <div class="check-style">
                <input v-model="dayClose" type="checkbox" id="ch-today" class="check-purple-round"><label for="ch-today">오늘 하루 보지 않기</label>
            </div>
            <button @click="closePopup()" class="close-event-popup">닫기</button>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import utils from '@/common/util/utils'
import { SESSION_STORAGE_SERVICE_END_POPUP_VIEW_KEY, URL_COOKIE_DOMAIN } from '@/common/constant'
import { getSessionStorage } from '@/common/util/storage.util'
export default {
  name: 'ServiceEndPopup',
  props: {
    showServiceEndPopup: {
      type: Boolean
    }
  },
  data () {
    return {
      dayClose: false,
      device: utils.cookies.getDevice(),
      popupState: true,
      endDay: new Date('2021-07-16'),
      endState: false
    }
  },
  methods: {
    chkEndDay () {
      let endDate = new Date()
      if (endDate >= this.endDay) {
        this.endState = true
      }
    },
    closePopup () {
      if (this.dayClose) {
        let expires = new Date()
        expires.setDate(expires.getDate() + 1)
        utils.cookies.setItem('service-end-popup', '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
      }
      this.popupState = false
    }
  },
  created () {
    this.chkEndDay()

    if (utils.cookies.getItem('service-end-popup') !== '1') {
      if (getSessionStorage().get(SESSION_STORAGE_SERVICE_END_POPUP_VIEW_KEY) !== 'y') {
        this.popupState = true
      }
    } else {
      this.popupState = false
    }
  }
}
</script>
<style scoped>
  .modal-container {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.8);
    -webkit-transition: opacity .3s ease;
    transition: opacity .3s ease;
    overflow-y: scroll;
  }

   .popup-event-wrap{
     position: absolute;
     width: 260px;
     top: 50%;
     margin-top: -202px;
     left: 50%;
     margin-left: -130px;
   }

   @media screen and (min-width: 360px){
     .popup-event-wrap{
       width: 315px;
       margin-top: -240px;
       margin-left: -157px;
     }
   }
   @media screen and (min-width: 768px){
     .popup-event-wrap{
       width: 315px;
       margin-top: -250px;
       margin-left: -165px;
     }
   }
  .popup-event-bottom{
    background: #fff;
    padding: 14px 20px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
  }

  .popup-event-bottom:after{
    content: "";
    display: block;
    clear: both;
  }

  .popup-event-bottom .check-style{
    float: left;
    display: inline-block;
  }
  .popup-event-bottom .check-style input[type=checkbox]+label{
    font-size: 14px;
    color: #a5a5a5;
  }
  .popup-event-bottom .check-style input[type="checkbox"].check-purple-round:focus + label:before{
    border: 1px #d9d9d9 solid;
  }
  .popup-event-bottom .check-style input[type="checkbox"].check-purple-round:checked + label:before{
    border: 1px solid #1351f9;
  }
  .close-event-popup{
    float: right;
    font-size: 14px;
    color: #a5a5a5;
    height: 24px;
  }
  .check-style input[type=checkbox] {
    position: absolute;
    clip: rect(0,0,0,0);
  }
  .check-style input[type=checkbox]+label {
    position: relative;
    font-size: 13px;
    letter-spacing: -.2px;
    color: #23212a;
  }
  /*보라색 체크박스- 원형*/
  .check-style input[type=checkbox].check-purple-round+label:before {
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    vertical-align: middle;
  }

  .check-style input[type=checkbox]+label:before {
    content: " ";
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-right: 8px;
  }
  .check-style input[type="checkbox"].check-purple-round + label:before{
    border-radius: 100px;
    border: 1px solid #d9d9d9;
    vertical-align: middle;
  }
  .check-style input[type="checkbox"].check-purple-round:focus + label:before{
    border: 1px solid #1351f9;
  }
  .check-style input[type="checkbox"].check-purple-round:checked + label:before{
    background: url(/img/common/check-purple.png) #1351f9 no-repeat center;
    background-size: 22px;
    border: 1px solid #1351f9;
  }
</style>
